module.exports = __webpack_public_path__ + "static/media/zam.d82beac4.svg";